import { IApplicationState } from '../../types/redux';

export const selectIsNewbuildingPromo = (state: IApplicationState) => {
  return state.activeFeature?.properties.isNewbuildingPromo || false;
};
